import Activity from '../../schema/Activity';
import ActivityType from '../../schema/innerSchema/ActivityType';
import ActivityTypeNames from '../../schema/innerSchema/ActivityTypeNames';
import CalendarEventOmission from '../../schema/innerSchema/CalendarEventOmission';
import Entity from '../../schema/Entity';
import EntityToActivityNameMapping from '../../schema/innerSchema/EntityToActivityNameMapping';
import RoleNames from '../../schema/innerSchema/RoleNames';
import { NO_CALENDAR_EVENT_ID } from '../../helpers/TxpConstants';

/**
 * create Activities item based on the input entities
 */
export default function createActivitiesFromEntities(entities: Entity[]): Activity[] {
    let activities: Activity[];

    if (entities) {
        activities = [];
        for (let i = 0; i < entities.length; i++) {
            let entity = entities[i];
            let activityName = EntityToActivityNameMapping[entity.entityName];
            let activityType = ActivityTypeNames[activityName];
            if (activityType) {
                activities.push(createActivity(entity.id, i, activityType, activityName));
            }
        }
    }

    return activities;
}

/**
 * parse the data into Activity item
 */
function createActivity(
    entityId: string,
    activityId: number,
    activityType: ActivityType,
    activityName: string
): Activity {
    // check if the properties in the blob - lowercase and save
    return {
        activityId: activityId.toString(),
        type: activityType,
        entityId: entityId,
        calendarEventIdIndex: NO_CALENDAR_EVENT_ID,
        eventOmission: CalendarEventOmission.None,
        role: RoleNames.primary,
        activityName: activityName,
    } as Activity;
}
